<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Дополнительные возможности - Планируемые поставки
                </h3>
            </div>
            <aside class="col-md-4">
                <MenuComponent/>
            </aside>
            <div class="col-md-8 mb-5">
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="postavkiRolo" name="postavkiRolo" class="custom-control-input" @change="get('postavkiRolo')" v-model="selects.postavkiRolo">
                            <label for="postavkiRolo" class="custom-control-label">Ткани для рулонных штор</label>
                        </div>
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="postavkiVert" name="postavkiVert" class="custom-control-input" @change="get('postavkiVert')" v-model="selects.postavkiVert">
                            <label for="postavkiVert" class="custom-control-label">Ткани для вертикальных жалюзи</label>
                        </div>
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="postavkiBand" name="postavkiBand" class="custom-control-input" @change="get('postavkiBand')" v-model="selects.postavkiBand">
                            <label for="postavkiBand" class="custom-control-label">Алюминиевая лента для горизонтальных жалюзи</label>
                        </div>
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="postavkiPlas" name="postavkiPlas" class="custom-control-input" @change="get('postavkiPlas')" v-model="selects.postavkiPlas">
                            <label for="postavkiPlas" class="custom-control-label">Пластик для вертикальных жалюзи</label>
                        </div>
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="postavkiPlisse" name="postavkiPlas" class="custom-control-input" @change="get('postavkiPlisse')" v-model="selects.postavkiPlisse">
                            <label for="postavkiPlisse" class="custom-control-label">Ткани для плиссе</label>
                        </div>
                    </div>
                </div>

                <div v-if="selects.postavkiRolo || selects.postavkiVert || selects.postavkiBand || selects.postavkiPlas || selects.postavkiPlisse" class="text-center mb-3">
                    Скачать <a href="javascript:" @click="getPdf()"><img src="@/assets/img/pdf.png" alt="PDF"></a>
                </div>

                <div v-if="selects.postavkiRolo" v-html="tables.postavkiRolo"></div>
                <div v-if="selects.postavkiVert" v-html="tables.postavkiVert"></div>
                <div v-if="selects.postavkiBand" v-html="tables.postavkiBand"></div>
                <div v-if="selects.postavkiPlas" v-html="tables.postavkiPlas"></div>
                <div v-if="selects.postavkiPlisse" v-html="tables.postavkiPlisse"></div>
            </div>
        </div>
    </main>
</template>

<script>
    import MenuComponent from '../components/AdditionalFeaturesMenu';
    import rm_katris from "../js/rm_katris/app";

    // rm_katris.params.url = 'https://sale.katris.ru/proxy/AI_HELPER_45745673029734/'; //debug ONLY

    export default {
        name: "AdditionalFeatures",
        metaInfo: {
            title: 'Планируемые поставки',
            titleTemplate: '%s - sale.katris'
        },
        components: {
            MenuComponent
        },
        data() {
            return {
                selects: {
                    postavkiRolo: false,
                    postavkiVert: false,
                    postavkiBand: false,
                    postavkiPlas: false,
                    postavkiPlisse: false
                },
                tables: {
                    postavkiRolo: '',
                    postavkiVert: '',
                    postavkiBand: '',
                    postavkiPlas: '',
                    postavkiPlisse: ''
                }
            }
        },
        created() {
            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');
        },
        methods: {
            get: function(type) {
                let self = this;
                rm_katris.makePost('katrisService', 'getDeliveries', {'token': this.$session.get('jwt'), shtable: type}, null, function(response) {
                    console.log(response)
                    if (response.status === 'OK') {
                        self.tables[type] = response.data;
                    }
                });
            },
            getPdf: function() {
                let self = this;
                let need = [];
                if (self.selects.postavkiRolo) need.push('postavkiRolo');
                if (self.selects.postavkiVert) need.push('postavkiVert');
                if (self.selects.postavkiBand) need.push('postavkiBand');
                if (self.selects.postavkiPlas) need.push('postavkiPlas');
                if (self.selects.postavkiPlisse) need.push('postavkiPlisse');
                rm_katris.makePost('katrisService', 'getDeliveriesPDF', {need: need, 'token': this.$session.get('jwt')}, null, function(response) {
                    if (response.status === 'OK') {
                        let newWindow = window.open("");
                        newWindow.document.write(
                            "<body style='margin:0'><iframe style='border: none;' width='100%' height='100%' src='data:application/pdf;base64, " +
                            encodeURI(response.data) + "'></iframe></body>"
                        )
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .card-body {
        padding: 10px;
    }
</style>